<template>
  <div>
    <h4>
      {{ taxonomyName }} terms list
      <router-link
        :to="{ name: 'terms.create', params: { taxonomy } }"
        class="btn btn-sm btn-primary">Create</router-link>
    </h4>
    <base-table
      ref="$baseTable"
      :resource="resource"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import find from 'lodash-es/find';
import get from 'lodash-es/get';
import BaseTable from '../components/BaseTable.vue';
import Proxy from './Proxy';

const resourceBase = 'terms';

export default {
  name: 'TermsIndex',

  components: {
    BaseTable,
  },

  data() {
    return {
      resource: {
        base: resourceBase,
        proxy() {
          return new Proxy();
        },
        beforeItemsRequest: (proxy) => {
          proxy.setParameter('where[taxonomy]', this.taxonomy);
        },
        sortBy: 'title',
        sortDesc: false,
        fields: [
          {
            key: 'id',
            label: 'ID',
            sortable: true,
          },
          {
            key: 'title',
            label: 'Title',
            sortable: true,
          },
          {
            key: 'order',
            label: 'Order',
            sortable: true,
          },
        ],

        // override search fields here using fields schema
        // searchFields: [
        // ],

        // define custom row actions
        // rowActions(item) {
        //   return [];
        // },

        // define custom bulk actions
        // bulkActions() {
        //   return [];
        // },
      },
    };
  },

  computed: {
    ...mapState('terms', [
      'taxonomies',
    ]),
    taxonomy() {
      return this.$route.params.taxonomy;
    },
    taxonomyName() {
      return get(find(this.taxonomies, { name: this.taxonomy }), 'label');
    },
  },

  watch: {
    taxonomy() {
      this.$refs.$baseTable.reset();
    },
  },
};
</script>
